export const CALENDAR_EVENT_COLOR = {
    RED: 'red',
    GRAY: 'grey',
} as const;

export const CALENDAR_EVENT_SOURCE_TYPE = {
    FLOW: 'flow',
    PROJECT: 'project',
} as const;